import { Injectable } from '@angular/core';

import { CopyService } from '@amfam/shared/utility/shared-services';

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  constructor(private copy: CopyService) {}

  public retrieveFaqContent(typeOfContent: string, options) {
    switch (typeOfContent) {
      case 'billing':
        return options.isPartner ? this.getDynamicFaq('partnerBilling', options) : [];

      case 'policy':
        return options.isPartner
          ? this.getDynamicFaq('parnterPolicy', options)
          : this.copy.getCopy('faq.policy');

      case 'goPaperless':
        return options.isPartner
          ? this.getDynamicFaq('goPaperlessPartner', options)
          : this.getDynamicFaq('goPaperless', options);

      case 'propertyClaims':
        return options.isPartner ? this.getDynamicFaq('propertyClaims', options) : [];

      case 'autoClaims':
        return options.isPartner ? this.getDynamicFaq('autoClaims', options) : [];

      default:
        return [];
    }
  }

  private getDynamicFaq(typeOfContent, options) {
    const contentArray = [];
    const tempContent = this.copy.getCopy(`faq.${typeOfContent}`);
    tempContent.forEach((content, i) => {
      const templatePiece = {
        title: this.copy.getCopy(`faq.${typeOfContent}[${i}].title`),
        body: this.copy.getCopy(
          `faq.${typeOfContent}[${i}].body`,
          {
            phoneNumber: options?.prettyPhoneNum,
            phoneNumberHref: options?.hrefPhoneNum,
            midvaleLink:
              options?.company === 'OnStar Insurance'
                ? 'https://osi.midvaleinsurance.com/OnlineServicing'
                : 'https://mypolicy.midvaleinsurance.com/OnlineServicing',
            payNowLink: options?.payNowLink,
            experienceId: options?.experienceId,
            policyType: options?.policies?.length > 0 ? options?.policies[0]?.policyType : '',
            policyNumber: options?.policies?.length > 0 ? options?.policies[0]?.policyNumber : ''
          },

          true
        )
      };
      contentArray.push(templatePiece);
    });
    return contentArray;
  }
}
